import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FbCoreModule } from '@fleet-beat/core';
import { EditorModule } from '@fleet-beat/editor';
import { CorePipesModule } from '@fleet-beat/libs-core/src/lib/pipes/core-pipes.module';
import { FormDialogContainerComponent } from './containers/form-dialog-container/form-dialog-container.component';

@NgModule({
  declarations: [FormDialogContainerComponent],
  imports: [
    FbCoreModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    CorePipesModule,
    MatRippleModule,
    EditorModule,
  ],
  providers: [],
  entryComponents: [FormDialogContainerComponent],
})
export class FormDialogModule {}
